/* wm-predictive-search: header search dropdown.
   Suggestions + collections: /search/suggest.json (Shopify Predictive Search API).
   Products: /search?type=product&section_id=wm-search-preview (full search ranking).
   No dependencies. If this file fails, the search form still submits to /search as before. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION = 'wm-search-preview';
  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 2;

  var inputs = document.querySelectorAll('form[action$="/search"] input[name="q"]');
  if (!inputs.length || !window.fetch || !window.DOMParser) return;

  var panel = document.createElement('div');
  panel.className = 'wm-ps';
  panel.hidden = true;
  panel.setAttribute('role', 'region');
  panel.setAttribute('aria-label', 'Search suggestions');
  panel.innerHTML =
    '<div class="wm-ps__inner">' +
      '<div class="wm-ps__main">' +
        '<div class="wm-ps__head"><span class="wm-ps__h">Products</span>' +
        '<a class="wm-ps__all" href="#">View all</a></div>' +
        '<div class="wm-ps__grid" aria-live="polite"></div>' +
        '<p class="wm-ps__empty" hidden></p>' +
      '</div>' +
      '<div class="wm-ps__side">' +
        '<div class="wm-ps__block" data-block="queries"><span class="wm-ps__h">Suggestions</span><ul class="wm-ps__list" data-list="queries"></ul></div>' +
        '<div class="wm-ps__block" data-block="collections"><span class="wm-ps__h">Collections</span><ul class="wm-ps__list" data-list="collections"></ul></div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(panel);

  var grid = panel.querySelector('.wm-ps__grid');
  var empty = panel.querySelector('.wm-ps__empty');
  var viewAll = panel.querySelector('.wm-ps__all');
  var lists = {
    queries: panel.querySelector('[data-list="queries"]'),
    collections: panel.querySelector('[data-list="collections"]')
  };

  var active = null;
  var timer = null;
  var controller = null;
  var seq = 0;
  var lastQuery = '';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function position() {
    if (!active) return;
    var r = active.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var w = Math.min(840, vw - 24);
    var left = Math.min(Math.max(12, r.right - w), vw - w - 12);
    panel.style.top = Math.round(r.bottom + 8) + 'px';
    panel.style.left = Math.round(left) + 'px';
    panel.style.width = Math.round(w) + 'px';
  }

  function open() { position(); panel.hidden = false; }
  function close() {
    panel.hidden = true;
    if (controller) controller.abort();
  }

  function renderList(list, items, kind) {
    var block = list.parentNode;
    if (!items.length) { list.innerHTML = ''; block.hidden = true; return; }
    block.hidden = false;
    list.innerHTML = items.map(function (it) {
      var text = kind === 'queries' ? it.text : it.title;
      return '<li><a href="' + esc(it.url) + '">' + esc(text) + '</a></li>';
    }).join('');
  }

  function searchUrl(q) {
    return ROOT + 'search?' + new URLSearchParams({ q: q, type: 'product' }).toString();
  }

  function getSuggestions(q, signal) {
    var params = new URLSearchParams({
      q: q,
      'resources[type]': 'query,collection',
      'resources[limit]': '8',
      'resources[limit_scope]': 'each'
    });
    return fetch(ROOT + 'search/suggest.json?' + params.toString(), {
      signal: signal, headers: { Accept: 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var res = (d && d.resources && d.resources.results) || {};
        return { queries: res.queries || [], collections: res.collections || [] };
      });
  }

  function getProducts(q, signal) {
    var params = new URLSearchParams({ q: q, type: 'product', section_id: SECTION });
    return fetch(ROOT + 'search?' + params.toString(), { signal: signal })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-wm-sp]');
        return node ? { html: node.innerHTML, count: Number(node.getAttribute('data-count')) || 0 } : { html: '', count: 0 };
      });
  }

  function run(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    var mine = ++seq;
    var signal = controller.signal;
    lastQuery = q;
    viewAll.href = searchUrl(q);
    panel.classList.add('wm-ps--loading');
    open();

    var s = getSuggestions(q, signal).catch(function (e) { if (e.name === 'AbortError') throw e; return { queries: [], collections: [] }; });
    var p = getProducts(q, signal).catch(function (e) { if (e.name === 'AbortError') throw e; return { html: '', count: 0 }; });

    Promise.all([s, p]).then(function (out) {
      if (mine !== seq) return;
      var sug = out[0], prod = out[1];
      renderList(lists.queries, sug.queries, 'queries');
      renderList(lists.collections, sug.collections, 'collections');
      grid.innerHTML = prod.html.trim();
      var hasProducts = !!grid.children.length;
      empty.hidden = hasProducts;
      viewAll.hidden = !hasProducts;
      if (!hasProducts) empty.textContent = 'No products found for \u201c' + q + '\u201d.';
      panel.classList.remove('wm-ps--loading');
      panel.classList.toggle('wm-ps--no-side', !sug.queries.length && !sug.collections.length);
    }).catch(function () { /* aborted by a newer keystroke */ });
  }

  function onInput(e) {
    active = e.target;
    var q = active.value.trim();
    clearTimeout(timer);
    if (q.length < MIN_CHARS) { close(); return; }
    timer = setTimeout(function () { run(q); }, DEBOUNCE_MS);
  }

  Array.prototype.forEach.call(inputs, function (input) {
    input.setAttribute('autocomplete', 'off');
    input.addEventListener('input', onInput);
    input.addEventListener('focus', function () {
      active = input;
      var q = input.value.trim();
      if (q.length >= MIN_CHARS) { q === lastQuery && grid.children.length ? open() : run(q); }
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); }
      if (e.key === 'ArrowDown' && !panel.hidden) {
        var first = panel.querySelector('a:not([hidden]):not([tabindex="-1"])');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
  });

  panel.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); if (active) active.focus(); }
  });
  /* Keep the header input from collapsing while the shopper clicks inside the panel. */
  panel.addEventListener('mousedown', function (e) {
    if (!e.target.closest('a')) e.preventDefault();
  });
  document.addEventListener('click', function (e) {
    if (panel.hidden) return;
    if (panel.contains(e.target)) return;
    if (active && (e.target === active || active.form && active.form.contains(e.target))) return;
    close();
  });
  window.addEventListener('resize', position);
  window.addEventListener('scroll', position, { passive: true });
})();
